import React from "react"
import Layout from "./src/components/Layout/Layout"
import SEOProvider from "./src/components/Provider/SEOProvider"
export const wrapPageElement = ({ element, props }) => (
  <SEOProvider>
    <Layout {...props}>{element}</Layout>
  </SEOProvider>
)
